import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { PROFILE } from "../data/content";

const LINKS = [
  { href: "#sobre", label: "Sobre" },
  { href: "#atuacao", label: "Atuação" },
  { href: "#avaliacao", label: "Avaliação" },
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#faq", label: "FAQ" },
  { href: "#contato", label: "Contato" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-40 w-full transition-all ${
        scrolled
          ? "backdrop-blur-xl bg-background/85 border-b border-border/60"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-3 md:py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex flex-col leading-tight"
        >
          <span className="font-serif-display text-lg md:text-xl text-royal-800">
            Drª Nivalda P. de Jesus
          </span>
          <span className="text-[11px] tracking-widest uppercase text-muted-foreground">
            {PROFILE.crp} • Santos/SP
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-foreground/80 hover:text-royal-800 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={PROFILE.doctoralia}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-doctoralia"
            className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-gold-700 hover:text-gold-600 transition-colors px-2"
          >
            ★ 5.0 Doctoralia
          </a>
          <a
            href={`tel:${PROFILE.phone_landline_tel}`}
            data-testid="navbar-phone"
            className="hidden md:inline-flex items-center gap-2 text-sm text-foreground/80 hover:text-royal-800 transition-colors"
          >
            <Phone size={14} />
            {PROFILE.phone_landline}
          </a>
          <Button
            asChild
            data-testid="navbar-cta-agendar"
            className="hidden md:inline-flex bg-royal-800 hover:bg-royal-700 text-white rounded-md"
          >
            <a href="#contato">Agendar consulta</a>
          </Button>
          <button
            data-testid="navbar-mobile-toggle"
            aria-label="Abrir menu"
            className="lg:hidden p-2 text-foreground"
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden border-t border-border bg-background/95 backdrop-blur-xl"
        >
          <div className="px-5 py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                className="text-base py-2 border-b border-border/60 text-foreground/90"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="navbar-mobile-cta"
              className="w-full bg-royal-800 hover:bg-royal-700 text-white mt-2"
            >
              <a href="#contato" onClick={() => setOpen(false)}>
                Agendar consulta
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
